import React from 'react'
import styled from 'styled-components'

import { Heading2 } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Row = styled.div`
  display: flex;
  column-gap: 16px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Item = styled.div`
  width: 50%;
  img {
    width: 100%;
  }
`

const Logo = () => {
  return (
    <>
      <Heading>Logo</Heading>
      <Row>
        <Item>
          <img src="/images/pusher-logo.png" alt="" />
        </Item>
        <Item>
          <img src="/images/pusher-logo-dark.png" alt="" />
        </Item>
      </Row>
      <Row>
        <Item>
          <img src="/images/channels-logo.png" alt="" />
        </Item>
        <Item>
          <img src="/images/channels-logo-dark.png" alt="" />
        </Item>
      </Row>
      <Row>
        <Item>
          <img src="/images/beams-logo.png" alt="" />
        </Item>
        <Item>
          <img src="/images/beams-logo-dark.png" alt="" />
        </Item>
      </Row>
    </>
  )
}

export default Logo
